import { API } from "aws-amplify";
import { getResourceLifeAccessRight } from "~/graphql/queries";
import { LoaderData } from "~/types";
import * as APITypes from "~/API";

export const EMPTY_RESOURCE_LIFE_ACCESS_RIGHT_INFO: APITypes.ResourceLifeAccessRight =
  {
    __typename: "ResourceLifeAccessRight",
    id: "",
    resourceType: APITypes.EntityType.Property,
    createAccessStatus: APITypes.ResourceAccessRightStatus.NotGranted,
    createAccessApproverID: "",
    createAccessApprovalDate: "",
    deleteAccessStatus: APITypes.ResourceAccessRightStatus.NotGranted,
    deleteAccessApproverID: "",
    deleteAccessApprovalDate: "",
    createdAt: "",
    updatedAt: "",
    _version: 0,
    _lastChangedAt: 0,
  };

export const getResourceLife = async ({
  userID,
  resourceType,
}: {
  userID?: string;
  resourceType?: APITypes.EntityType;
}): Promise<LoaderData<APITypes.ResourceLifeAccessRight>> => {
  try {
    const id = `${userID}-${resourceType}`;
    const response = (await API.graphql({
      query: getResourceLifeAccessRight,
      variables: {
        id,
      },
    })) as { data?: APITypes.GetResourceLifeAccessRightQuery };

    return {
      success: true,
      data:
        response.data?.getResourceLifeAccessRight ||
        EMPTY_RESOURCE_LIFE_ACCESS_RIGHT_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_RESOURCE_LIFE_ACCESS_RIGHT_INFO,
      error,
    };
  }
};
